
export const ARTICELS_LIST_REQUEST = 'ARTICELS_LIST_REQUEST'
export const ARTICELS_LIST_REQUEST_SUCCESS = 'ARTICELS_LIST_REQUEST_SUCCESS'
export const ARTICELS_LIST_REQUEST_FAIL = 'ARTICELS_LIST_REQUEST_FAIL'

export const ARTICEL_REQUEST = 'ARTICEL_REQUEST'
export const ARTICEL_REQUEST_SUCCESS = 'ARTICEL_REQUEST_SUCCESS'
export const ARTICEL_REQUEST_FAIL = 'ARTICEL_REQUEST_FAIL'

export const ADMIN_ARTICEL_REQUEST = 'ADMIN_ARTICEL_REQUEST'
export const ADMIN_ARTICEL_REQUEST_SUCCESS = 'ADMIN_ARTICEL_REQUEST_SUCCESS'
export const ADMIN_ARTICEL_REQUEST_FAIL = 'ADMIN_ARTICEL_REQUEST_FAIL'
export const ADMIN_ARTICEL_REQUEST_RESET = 'ADMIN_ARTICEL_REQUEST_RESET'
